import Address from "../../../../src/components/address/Address";
import * as React from 'react';
export default {
  Address,
  React
};